import { HttpContextToken } from '@angular/common/http';

/**
 * HttpContextToken to skip authentication interceptor
 * Used for requests that should not include Authorization header (e.g., S3 presigned URLs)
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
